import { AlertModal, Para, Stack } from '@drycut/ui-components';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
};

export default function HoldConfirmation({ open, onClose, onConfirm }: Props): React.ReactElement {
  return (
    <AlertModal
      open={open}
      title="On hold"
      onClose={onClose}
      onConfirm={onConfirm}
      yesButtonLabel="Bestätigen"
      noButtonLabel="Cancel"
    >
      <Stack gap={3} className="text-pretty">
        <Para size="lg">
          Bist Du sicher, dass Du diesen Kunden in die No Show Queue verschieben willst?
        </Para>

        <Para size="lg">
          Wenn der Kunde erscheint, kannst Du ihn jederzeit an das Ende der Warteschlange setzen.
        </Para>
      </Stack>
    </AlertModal>
  );
}
